import { useEffect, useState } from 'react';

/**
 * Держит компонент смонтированным на время exit-анимации.
 * active → класс .is-visible; mounted → можно рендерить.
 */
export function useMountTransition(open, durationMs = 320) {
  const [mounted, setMounted] = useState(Boolean(open));
  const [active, setActive] = useState(Boolean(open));

  useEffect(() => {
    let rafOuter = 0;
    let rafInner = 0;
    let timer = 0;

    if (open) {
      setMounted(true);
      rafOuter = window.requestAnimationFrame(() => {
        rafInner = window.requestAnimationFrame(() => setActive(true));
      });
    } else {
      setActive(false);
      timer = window.setTimeout(() => setMounted(false), durationMs);
    }

    return () => {
      if (rafOuter) window.cancelAnimationFrame(rafOuter);
      if (rafInner) window.cancelAnimationFrame(rafInner);
      if (timer) window.clearTimeout(timer);
    };
  }, [open, durationMs]);

  return { mounted, active };
}
